import { cn } from '../../utils/cn'
// Negrito inline via **...**
function rich(text) {
  return text.split('**').map((part, index) =>
    index % 2 === 1 ? (
      <strong key={index} className="font-inter-bold">
        {part}
      </strong>
    ) : (
      part
    ),
  )
}

// blocks: array ordenado de { type: 'p', text } | { type: 'quote', text, author }
export default function PressReleaseCard({
  heading,
  intro = '',
  eyebrow = 'EXEMPLO DE PRESS RELEASE',
  headline = '',
  blocks = [],
  accentBorderClass = 'border-[#FF4D1C]',
}) {
  const introParagraphs = Array.isArray(intro) ? intro : [intro]

  return (
    <div className="w-full px-20">
      {heading && (
        <h2 className="pb-6 font-inter-extrabold text-2xl leading-[1.08] tracking-[-0.02em] text-[#454545]">
          {heading}
        </h2>
      )}

      {introParagraphs.some(Boolean) && (
        <div className="flex flex-col gap-4 pb-6">
          {introParagraphs.filter(Boolean).map((paragraph, index) => (
            <p
              key={index}
              className="font-inter-regular text-base leading-[1.4] tracking-[-0.02em] text-[#454545]"
            >
              {rich(paragraph)}
            </p>
          ))}
        </div>
      )}

      <div className="rounded-[10px] border border-[#E0E0E0] bg-[#F8F8F8] px-10 pt-[30px] pb-10">
        <span className="font-jetbrains-mono text-xs uppercase tracking-[0.05em] text-[#6A7282]">
          {eyebrow}
        </span>

        <h3 className="mt-[31px] font-inter-bold text-[30px] leading-none text-[#454545]">
          {headline}
        </h3>

        <div className="mt-6 flex flex-col gap-6">
          {blocks.map((block, index) =>
            block.type === 'quote' ? (
              <div
                key={index}
                className={cn('border-l-4 pl-6', accentBorderClass)}
              >
                <p className="font-inter-regular text-lg italic leading-[28px] text-[#333333]">
                  {block.text}
                  {block.author && <span> — {block.author}</span>}
                </p>
              </div>
            ) : (
              <p
                key={index}
                className="font-inter-regular text-base leading-[26px] text-[#454545]"
              >
                {block.text}
              </p>
            ),
          )}
        </div>
      </div>
    </div>
  )
}
